import React from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import LeafDecoration from "./LeafDecoration";

const Layout = ({ children }) => {
  return (
    <div className="relative min-h-screen bg-[#F5F3EE]">
      <Navigation />
      <LeafDecoration />
      <main className="relative z-10">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;